import { render } from "./ReportePedidos.vue?vue&type=template&id=0c7cb772&scoped=true"
import script from "./ReportePedidos.vue?vue&type=script&lang=js"
export * from "./ReportePedidos.vue?vue&type=script&lang=js"

import "./ReportePedidos.vue?vue&type=style&index=0&id=0c7cb772&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7cb772"]])

export default __exports__